<script>
import NowaRecepta from "@/components/clients/NowaRecepta.vue";
import * as dayjs from "dayjs";
import swal from "sweetalert";
import {receptyService} from "@/services";
import PokoPdfViewer from "@/components/shared/PokoPDFViewer.vue";
import HasloCertyfikatu from "@/components/clients/HasloCertyfikatu.vue";
import {mapState} from "vuex";

export default {
  name: "Recepty",
  components: {HasloCertyfikatu, PokoPdfViewer, NowaRecepta},
  props: ["clientid", "visitid", "therapistid"],
  data() {
    return {
      nowa_recepta_dialog: false,
      items: [],
      options: {},
      pagination: {},
      totalCount: 0,
      showViewer: false,
      pdfData: null,
      edytowanyPakiet: null,
      certPassword: null,
      showGetPassword: false,
      title_edycja_tworzenie: 'Nowy pakiet recept',
      headers: [
        { text: 'Data utworzenia', sortable: true, align: 'left', value: 'createDate'},
        { text: 'Twórca', sortable: true, align: 'left', value: 'tworca'} ,
        { text: 'Status', sortable: false, align: 'left', value: 'status'},
        { text: 'Leki', sortable: false, align: 'left', value: 'leki'},
        { text: 'Akcje', sortable: false, align: 'left', value: 'id'}
      ],
      loading: false,
      pakiety: [],
    }
  },
  methods: {
    showError( text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {

      });
    },
    closeViewer()
    {
      this.showViewer = false
      this.pdfData = null
    },
      getStatusDescription(status) {
      switch (status){
        case 0:
          return 'Nowa';
        case 1:
          return 'Wysłana do P1';
        case 2:
          return 'Anulowana';
      }
      return '';
    },
    getData() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      let sortValue = ''
      if(sortBy.length > 0)
      {
        sortValue = sortBy[0]
        if(sortDesc.length > 0)
          sortValue = sortBy[0] + ( sortDesc[0] ? " DESC": "");
      }
      this.loading = true
      receptyService.getPakiety({
        Sorting: sortValue,
        SkipCount: (page-1) * itemsPerPage,
        MaxResultCount: itemsPerPage,
        client_id: this.clientid
      }).then(result=>{
        this.pakiety = result.data.result.items
        this.totalCount = result.data.result.totalCount
        this.loading = false
      }).catch(() => {
        this.showError('Bład pobierania pakietów recept')
        this.loading = false
      })

    },
    dodajRecepte() {
      this.edytowanyPakiet = null;
      this.title_edycja_tworzenie = 'Nowy pakiet recept';
      this.nowa_recepta_dialog = true;
    },
    closePakiet() {
      this.edytowanyPakiet = null;
      this.title_edycja_tworzenie = 'Nowy pakiet recept';
      this.nowa_recepta_dialog = false;
      this.getData()
    },
    editPakiet(id) {
      receptyService.getPakietRecept(id).then((response) => {
        this.edytowanyPakiet = response.data.result
        this.title_edycja_tworzenie = 'Edycja pakietu recept';
        this.nowa_recepta_dialog = true;
      }).catch(() => {
        this.showError('Bład pobierania pakietu recept')
      });
    },
    getFormattedDate(val)
    {

      if(val) {
        let dj = dayjs(val)

        if (dj != null) {
          return dj.format("DD-MM-YYYY HH:mm")
        } else {
          return ''
        }
      }
      return ''
    },
    pobierzPdf(id) {
      if(this.wymagane_haslo_certyfikatu && !this.certPassword)
      {
        this.showGetPassword = true
        return
      }

      receptyService.pobierzPdf(id,this.certPassword).then((response) => {
        let data = response.data.result
        if(data && data.length > 0) {
          this.pdfData = data
          this.showViewer = true;
        }
        else
        {
          this.showError('Brak dokumentu do wyświetlenia')
        }
      }).catch((error)=> {
        let err =error.response

        if(err.data != null && err.data.error && err.data.error.message)
        {
          if(err.data.error.message.includes('hasło certyfikatu'))
          {
            this.certPassword = null
          }
          this.showError(err.data.error.message)
        }
        else
        {
          this.showError("Nie zapisać recepty")
        }
      });
    },
    checkPakiet(id) {
      if(this.wymagane_haslo_certyfikatu && !this.certPassword)
      {
        this.showGetPassword = true
        return
      }
      receptyService.sprawdzPakiet(id,this.certPassword).then((response) => {
        let data = response.data.result
        if(data == null || data.length == 0)
        {
          swal({
            title: "Wszystko w porządku",
            text: "Recepta zweryfikowana poprawnie",
            icon: "success",
            button: "OK"
          }).then(() => {

          });
        }
        else
        {
          var html_message = '';
          data.forEach(elem => {
            html_message += '' + elem +'\n';
          })
          if(html_message.includes('hasło certyfikatu'))
          {
            this.certPassword = null
          }
          swal({
            title: "Błąd",
            text: html_message,
            icon: "warning",
            button: "OK"
          }).then(() => {

          });
        }
      }).catch((error)=> {
        let err =error.response

        if(err.data != null && err.data.error && err.data.error.message)
        {
          if(err.data.error.message.includes('hasło certyfikatu'))
          {
            this.certPassword = null
          }
          this.showError(err.data.error.message)
        }
        else
        {
          this.showError("Nie zapisać recepty")
        }
      });
    },
    closeGetPasword() {
      this.showGetPassword = false
    },
    saveGetPassword(pass) {
      this.showGetPassword = false
      this.certPassword = pass
    },
    createPakiet(id) {
      if(this.wymagane_haslo_certyfikatu && !this.certPassword)
      {
        this.showGetPassword = true
        return
      }
      receptyService.createPakiet(id,this.certPassword).then((response) => {
        let data = response.data.result
        if(data == null || data.length == 0)
        {
          swal({
            title: "Wszystko w porządku",
            text: "Recepta wysłana do systemu P1 poprawnie",
            icon: "success",
            button: "OK"
          }).then(() => {
            this.getData()
          });
        }
        else
        {
          var html_message = '';
          data.forEach(elem => {
            html_message += '' + elem +'\n';
          })
          swal({
            title: "Błąd",
            text: html_message,
            icon: "warning",
            button: "OK"
          }).then(() => {

          });
        }
      }).catch((error)=> {
        let err =error.response
        if(err.data != null && err.data.error && err.data.error.message)
        {
          if(err.data.error.message.includes('hasło certyfikatu'))
          {
            this.certPassword = null
          }
          this.showError(err.data.error.message)
        }
        else
        {
          this.showError("Nie zapisać recepty")
        }
      });
    },
    wyslijSms(pakietid)
    {
      receptyService.wyslijSmsPakietu(pakietid).then(() => {
        swal({
          title: "Wysyłka sms",
          text: "Sms wysłany poprawnie",
          icon: "success",
          button: "OK"
        }).then(() => {

        });
      }).catch((error)=> {
        let err =error.response
        if(err.data != null && err.data.error && err.data.error.message)
        {
          this.showError(err.data.error.message)
        }
        else
        {
          this.showError("Nie wysłano sms")
        }
      });
    }
  },
  computed: {
    ...mapState('account', ['userdetails']),
    wymagane_haslo_certyfikatu: function() {
      return this.userdetails != null && this.userdetails.therapistDetails != null && this.userdetails.therapistDetails.czyWymagaHaslaCertyfikatu;
    }
  },
  watch: {
    options: {
      handler () {
        this.getData()
      },
      deep: true,
    },
  }
}
</script>

<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="dodajRecepte">Nowa recepta</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table
            :headers="headers"
            :items="pakiety"
            :options.sync="options"
            :server-items-length="totalCount"
            :loading="loading"
            :footer-props="{itemsPerPageOptions:[50,100,200,500],}"
            class="elevation-1"
        >
          <template v-slot:item="props">
            <tr>
              <td>{{getFormattedDate(props.item.createDate)}}</td>
              <td>{{props.item.tworca}}</td>
              <td>{{getStatusDescription(props.item.status)}}</td>
              <td>{{props.item.leki}}</td>
              <td>
                <v-icon small class="mr-2" @click="editPakiet(props.item.id)" color="primary"  title="Sprawdz szczegóły pakietu">fa-edit</v-icon>
                <v-icon  v-if="props.item.status == 0" small class="mr-2" @click="deletePakiet(props.item.id)" color="danger"  title="Usuń pakiet recept">fa-trash</v-icon>
                <v-icon v-if="props.item.status == 0" small class="mr-2" @click="checkPakiet(props.item.id)" color="warning"  title="Sprawdź poprawność pakietu z systemem P1">fa-user-check</v-icon>
                <v-icon v-if="props.item.status == 0" small class="mr-2" @click="createPakiet(props.item.id)" color="success"  title="Wyślij pakiet recept do systemu P1">fa-file-import</v-icon>
                <v-icon v-if="props.item.status == 1" small class="mr-2" @click="pobierzPdf(props.item.id)" color="primary"  title="Pobierz wydruk PDF">fa-file-pdf</v-icon>
                <v-icon v-if="props.item.status == 1" small class="mr-2"  @click="wyslijSms(props.item.id)" color="#e298f5"  title="Wyślij sms z receptą">fa-sms</v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row v-if="nowa_recepta_dialog">
      <v-dialog v-model="nowa_recepta_dialog" fullscreen persistent>
        <v-card>
          <v-toolbar dark class="primary">
            <v-btn icon @click.native="nowa_recepta_dialog = false" dark>
              <v-icon>fa-times</v-icon>
            </v-btn>
            <v-toolbar-title>{{title_edycja_tworzenie}}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <NowaRecepta v-if="nowa_recepta_dialog" :clientid="clientid" :therapistid="therapistid" :visitid="visitid" @close="closePakiet" :pakiet="edytowanyPakiet"></NowaRecepta>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
    <PokoPdfViewer :pdf-data="pdfData" v-if="showViewer" :visible="showViewer" @close="closeViewer"></PokoPdfViewer>
    <HasloCertyfikatu v-if="showGetPassword" :visible="showGetPassword" @close="closeGetPasword" @save="saveGetPassword"></HasloCertyfikatu>
  </v-container>
</template>

<style scoped>
</style>